<template>
    <v-container>
        <loading-spinner v-if="loading" />
        <div v-else>
            <back-button fixed />
            <div class="white-card">
                <v-row align="center">
                    <v-col cols="12">
                        <div class="title-section mb-6">
                            {{ $t('routines.add_blocks_and_exercises') }}
                        </div>
                        <routine-blocks class="px-4" ref="blocksManager" :default-blocks="blocks"
                            @change="blocks = $event" />
                    </v-col>
                    <v-col cols="12 text-right">
                        <v-btn color="primary" class="normal-btn black--text" small depressed @click="saveBlock"
                            :loading="saving">
                            {{ $t('common.save') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </div>
    </v-container>
</template>

<script>


import { db } from '@/utils/Firebase'
import BackButton from "@/components/common/BackButton";
import LoadingSpinner from "@/components/common/LoadingSpinner";
import RoutineBlocks from "@/components/coach/routines/RoutineBlocks";
import { sumDuration } from "@/utils/Exercises"

export default {
    components: {
        LoadingSpinner,
        BackButton,
        RoutineBlocks
    },
    data() {
        return {
            loading: false,
            saving: false,
            program: null,
            blocks: [{ exercises: [] }],
            currentError: '',
        }
    },
    computed: {
        programId(vm = this) {
            return vm.$route.params.uid || null
        },
        routineId(vm = this) {
            return vm.$route.params.id
        },
        disabled(vm = this) {
            return !vm.name || !vm.folder || vm.block.exercises.length === 0 || vm.block.exercises.some(ex => !ex.config || ex?.config?.sets?.length === 0)
        },
        routine(vm = this) {
            return vm.program?.assignedRoutines[vm.routineId] || null
        },
        isValid(vm = this) {
            vm.currentError = ''
            if (vm.blocks.length === 0) {
                vm.currentError = vm.$t('routines.routine_blocks_required')
                return false
            }
            let blockValid = true

            vm.blocks.forEach(block => {
                if (block.exercises.length === 0) {
                    vm.currentError = vm.$t('routines.routine_exercises_required')
                    return blockValid = false
                }

                if (block.exercises[0].type === 'rest') {
                    vm.currentError = 'No se puede agregar un descanso al comienzo'
                    return blockValid = false
                }

                let qtyExerciseWithConfig = 0
                let qtyRestContinuos = 0
                block.exercises.forEach(exercise => {
                    if (exercise.type !== 'rest' && exercise.config && exercise.config.sets.length > 0) qtyExerciseWithConfig++
                    if (exercise.type === 'rest') {
                        qtyRestContinuos++
                        if (qtyRestContinuos === 2) {
                            vm.currentError = 'No se puede tener 2 descansos seguidos'
                            return blockValid = false
                        }
                    } else {
                        qtyRestContinuos = 0
                    }
                })

                if (qtyExerciseWithConfig !== block.exercises.filter(ex => ex.type !== 'rest').length) {
                    vm.currentError = vm.$t('routines.routine_sets_required')
                    return blockValid = false
                }
            })

            return blockValid
        },
    },
    async mounted() {
        const vm = this
        await vm.loadProgram()
    },
    methods: {
        async loadProgram() {
            const vm = this
            vm.loading = true
            let programRef = await db.collection('programs').doc(vm.programId).get()
            vm.program = programRef.data()
            vm.blocks = vm.routine.blocks || []
            vm.loading = false
        },
        async saveBlock() {
            const vm = this;
            if (!vm.isValid) return vm.toast(vm.currentError, 'error')
            vm.saving = true
            let assignedRoutines = [...vm.program.assignedRoutines]

            assignedRoutines[vm.routineId].blocks = vm.blocks?.map((block, i) => {
                let blockDuration = sumDuration(block.exercises)
                return {
                    id: Number(i) + 1,
                    duration: blockDuration.duration,
                    unit: blockDuration.unit,
                    exercises: block.exercises && block.exercises.map(exercise => {
                        return {
                            name: exercise.name || '',
                            type: exercise.type || 'exercise',
                            time: exercise.time || '',
                            hasTime: !!exercise.time,
                            objectID: exercise.id || exercise.objectID || '',
                            config: exercise.config || null,
                            id: exercise.id || exercise.objectID || '', //todo remove id after testing components compatibility
                        }
                    }) || []
                }
            }) || []

            await db.collection('programs').doc(vm.programId).update({ assignedRoutines: assignedRoutines })
            vm.saving = false
            vm.toast(vm.$t('programs.saved'))
            vm.$router.back()
        },
    }

}

</script>

<style scoped>
.title-section {
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: #333333;
    text-align: center;
    margin-top: 20px;
}
</style>